import { AbstractControl, ValidatorFn } from '@angular/forms';

export function getParentMultiSelectRequiredValidator(): ValidatorFn {
   return (control: AbstractControl) => {
      const value = control.value;
      if (!value.all && value.phoneNumbers?.length === 0) {
         return { required: true };
      }
      return null;
   };
}
